export default "__VITE_ASSET__CtZU5n1N__"